import './home.scss';

import React, { useContext, useEffect, useState } from 'react';
import { useAppSelector } from 'app/config/store';
import { ToastContext } from 'app/context/ToastContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatDateFromInstant } from 'app/shared/util/date-utils';
import { Button } from 'primereact/button';
import { downloadDocument } from 'app/api/downloadDocumentApi';

export const LastUploadedDocumentsComponent = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const navigate = useNavigate();

  const account = useAppSelector(state => state.authentication.account);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [latestDocuments, setLatestDocuments] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);

    axios
      .get('/api/download-document/latest/5')
      .then(response => {
        setLatestDocuments(response.data);
      })
      .catch(error => {
        showError('Chyba', error.response?.data?.detail);
        console.error('Error fetching latest documents:', error);
      })
      .finally(() => setLoading(false));
  };

  const onDownload = (id, filename) => {
    downloadDocument(id, filename);
  };

  const actionBodyTemplate = rowData => {
    return (
      <React.Fragment>
        <div className="flex justify-content-around">
          <Button
            style={{ width: '1rem', height: '2rem', backgroundColor: 'gray', borderColor: 'gray' }}
            icon="pi pi-download"
            size="small"
            className="p-button-rounded p-button-success mr-1"
            tooltip="Stiahnuť"
            onClick={() => onDownload(rowData.id, rowData.name)}
          />
        </div>
      </React.Fragment>
    );
  };

  return (
    <div>
      <h5>Posledné pridané dokumenty</h5>
      {latestDocuments.length > 0 ? (
        <DataTable stripedRows value={latestDocuments}>
          <Column field="name" header="Názov" />
          <Column field="uploadDate" header="Nahraté dňa" body={r => formatDateFromInstant(r.uploadDate)} />
          <Column body={actionBodyTemplate} header="Akcie" exportable={false} style={{ justifyContent: 'end' }}></Column>
        </DataTable>
      ) : (
        <p>Žiadne nahraté dokumenty.</p>
      )}
    </div>
  );
};

export default LastUploadedDocumentsComponent;
